import { createStore } from '@'

export const $roles = createStore('roles:roles')
export const $resourcePermissions = createStore('roles:resourcePermissions')
export const $permissions = createStore('roles:permissions')
